module.exports = __webpack_public_path__ + "static/assets/f231056019ffe328e58432393f6102c5.svg";